'use client';
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { toast } from 'react-toastify';
import { useState, useEffect, useRef } from 'react';
import JobCategoriesSelector from "../job-board/Components/JobCategoriesSelector";
import "./PostJob.css";
import jobApi from "../../services/jobApi";
import contactApi from "../../services/contactApi";
import { IoCaretDownSharp } from "react-icons/io5";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";
import modalTexts from '../../config/modalTexts.json';
import strings from "../../config/App.json";
import '../blogs/[category]/Blogs.css';
import '../einbuergerungstest/ToolDetailsPage.css';
import '../job-board/JobBoard.css';
import '../contact/Contact.css';
import '../../components/SearchBar/SearchBar.css';
import '../einbuergerungstest/mocktest/bavaria/StateSelection.css';
import '../job-board/Components/FilterPanel.css';

export default function PostJob() {
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null);
    const panelRef = useRef(null);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);

    const [formData, setFormData] = useState({
        company_name: '',
        jobTitle: '',
        description: '',
        link: '',
        email: '',
        contactNo: '',
        jobType: '',
        jobLocation: ''
    });

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const storedTags = localStorage.getItem("jobTags");
        if (storedTags) setTags(JSON.parse(storedTags));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const resetForm = () => {
        setFormData({
            company_name: '',
            jobTitle: '',
            description: '',
            link: '',
            email: '',
            contactNo: '',
            jobType: '',
            jobLocation: ''
        });
        setSelectedCategories([]);
        setIsSubmitted(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.company_name.trim()) {
            toast.error("Company name is required");
            return;
        }
        if (!formData.jobTitle.trim()) {
            toast.error("Job title is required");
            return;
        }
        if (!formData.description.trim()) {
            toast.error("Job description is required");
            return;
        }
        if (!formData.jobType.trim()) {
            toast.error("Please select a job type");
            return;
        }
        if (!formData.jobLocation.trim()) {
            toast.error("Please select a job location");
            return;
        }
        if (selectedCategories.length === 0) {
            toast.error("Please select at least one job category");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                company_name: formData.company_name,
                sender_email: formData.email,
                job_title: formData.jobTitle,
                job_description: formData.description,
                job_link: formData.link,
                contactNo: formData.contactNo,
                job_types: [formData.jobType],
                locations: [formData.jobLocation],
                tags: selectedCategories,
                company_logo_link: "https://example.com/logo.png"
            };

            const response = await jobApi.PostJob(payload);

            if (response.data && response.data.success) {
                const jobDetails = response.data.data;

                const emailBody = {
                    sender: jobDetails.company_name,
                    sender_email: jobDetails.sender_email,
                    sender_comments: jobDetails.job_description,
                    company_name: jobDetails.company_name,
                    company_logo_link: jobDetails.company_logo_link,
                    job_title: jobDetails.job_title,
                    job_description: jobDetails.job_description,
                    job_link: jobDetails.job_link,
                    approval_link: jobDetails.approval_link,
                    rejection_link: jobDetails.rejection_link
                };

                await contactApi.JobsRequest(emailBody);

                toast.success("Job posted successfully!");
                resetForm();
                setIsSubmitted(true);
            } else {
                toast.error(response.data?.error || "Failed to post job");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error posting job");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className="job-content">
                <div className="background-ellipses">
                    <div className="ellipse ellipse-1"></div>
                    <div className="ellipse ellipse-2"></div>
                </div>
                <div className="page-container">
                    <h1 className="Job_title" id="Post_job_title">Post your job on Munich Indians</h1>
                    <p className="Job_des" id="Post_job_des"> Hire professionals in Munich</p>

                    <div className="Post-Job-container">
                        {isSubmitted ? (
                            <div className="response-received">
                                <h2 className='Contact-Header' id="post-job-title">Thank you! 🙂</h2>
                                <p className='thanksMsg'>We’ve received your job post. <br />Our team will rectify the details and get back to you shortly.</p>
                            </div>
                        ) : (
                            <form className="contact-form" onSubmit={handleSubmit} ref={panelRef}>
                                <h2 className='Contact-Header' id="post-job-title">Tell us about your role</h2>
                                <div className="form-group">
                                    <label htmlFor="company_name">Company Name<span className="text-style-1">*</span></label>
                                    <input
                                        type="text"
                                        id="company_name"
                                        name="company_name"
                                        value={formData.company_name}
                                        onChange={handleChange}
                                        placeholder='Company Name'
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="jobTitle">Job Title<span className="text-style-1">*</span></label>
                                    <input
                                        type="text"
                                        id="jobTitle"
                                        name="jobTitle"
                                        value={formData.jobTitle}
                                        onChange={handleChange}
                                        placeholder='Job Title'
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="description">Job Description<span className="text-style-1">*</span></label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder="Type here..."
                                        required
                                    />
                                </div>
                                <div className='form-flex'>
                                    <div className="form-group">
                                        <label htmlFor="jobType">Job Type<span className="text-style-1">*</span></label>
                                        <div
                                            className="custom-dropdown_filter"
                                            onClick={() =>
                                                setOpenDropdown(openDropdown === "jobType" ? null : "jobType")
                                            }
                                        >
                                            <div className="custom-dropdown-selected">
                                                {formData.jobType || "Select Job Type"}
                                                <IoCaretDownSharp
                                                    className={`dropdown-arrow ${openDropdown === "jobType" ? "rotate" : ""}`}
                                                />
                                            </div>
                                            {openDropdown === "jobType" && (
                                                <div className="custom-dropdown-options">
                                                    {["Full-time", "Part-time", "Contract", "Internship"].map((option, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="custom-dropdown-option"
                                                            onClick={() => {
                                                                setFormData((prev) => ({ ...prev, jobType: option }));
                                                                setOpenDropdown(null);
                                                            }}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="jobLocation">Job Location<span className="text-style-1">*</span></label>
                                        <div
                                            className="custom-dropdown_filter"
                                            onClick={() =>
                                                setOpenDropdown(openDropdown === "jobLocation" ? null : "jobLocation")
                                            }
                                        >
                                            <div className="custom-dropdown-selected">
                                                {formData.jobLocation || "Select Location"}
                                                <IoCaretDownSharp
                                                    className={`dropdown-arrow ${openDropdown === "jobLocation" ? "rotate" : ""}`}
                                                />
                                            </div>
                                            {openDropdown === "jobLocation" && (
                                                <div className="custom-dropdown-options">
                                                    {["Munich", "Remote"].map((option, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="custom-dropdown-option"
                                                            onClick={() => {
                                                                setFormData((prev) => ({ ...prev, jobLocation: option }));
                                                                setOpenDropdown(null);
                                                            }}
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Job Categories<span className="text-style-1">*</span></label>
                                    <JobCategoriesSelector
                                        tags={tags}
                                        onChange={(tags) => setSelectedCategories(tags)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="link">Link to the career page / job post</label>
                                    <input
                                        type="text"
                                        id="link"
                                        name="link"
                                        value={formData.link}
                                        onChange={handleChange}
                                        placeholder='Paste Link'
                                    />
                                </div>
                                <div className='form-flex'>
                                    <div className="form-group">
                                        <label htmlFor="email">Email ID of hiring team</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder='Email ID'
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="contactNo">Contact No. of hiring team</label>
                                        <input
                                            type="text"
                                            id="contactNo"
                                            name="contactNo"
                                            value={formData.contactNo}
                                            onChange={handleChange}
                                            placeholder='Contact'
                                        />
                                    </div>
                                </div>
                                <div className="btnFlex">
                                    <button type="button" className="apply-btn" id="cancle-btn" onClick={() => setCancelModalOpen(true)}>
                                        Cancel
                                    </button>
                                    <button type="submit" disabled={loading} className="apply-btn">
                                        {loading ? 'Posting...' : 'Post Job'}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
            <ConfirmModal
                isOpen={isCancelModalOpen}
                title={modalTexts.cancelJob_post.title}
                subtitle={modalTexts.cancelJob_post.subtitle}
                confirmText={modalTexts.cancelJob_post.confirmText}
                cancelText={modalTexts.cancelJob_post.cancelText}
                onConfirm={() => {
                    resetForm();
                    setCancelModalOpen(false);
                    toast.info("Form cleared");
                    window.location.href = strings.JobBoardPage;
                }}
                onCancel={() => {
                    setCancelModalOpen(false);
                }} />
        </>
    );
}
